export default __webpack_public_path__ + "static/media/familie.feb00a55.svg";